import React, {Component} from "react";
import Pagination from "react-js-pagination";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faAngleRight} from "@fortawesome/free-solid-svg-icons/faAngleRight";
import {faAngleLeft} from "@fortawesome/free-solid-svg-icons/faAngleLeft";
import {faAnglesLeft} from "@fortawesome/free-solid-svg-icons/faAnglesLeft";
import {faAnglesRight} from "@fortawesome/free-solid-svg-icons/faAnglesRight";

export default class Paginate extends Component{

    constructor(props) {
        super(props);

        this.state={
            activePage: props.currentPage || 1,
            totalCount : props.totalCount || 0,
            limit : props.limit || 50,
            pageRane : 5,
        }
    }

    handlePageClick = (page) => {
        this.setState({activePage: page},()=>{
            this.props.onPageClick(page);
        })
    }

    render(){

        let { activePage, totalCount, limit, pageRane } = this.state;

        //Skip showing pagination when total numbers of rows less than REACT_APP_RECORDS_PER_PAGE env vairable
        if(totalCount <= limit /*process.env["REACT_APP_RECORDS_PER_PAGE"]*/){
            return  <></>
        }

        return (
            <Pagination
                activePage={activePage}
                itemsCountPerPage={limit}
                totalItemsCount={totalCount}
                pageRangeDisplayed={pageRane}
                onChange={this.handlePageClick}
                activeLinkClass={`pagination-active`}
                linkClass={`pagination-active-link`}
                prevPageText={<FontAwesomeIcon icon={faAngleLeft}/>}
                nextPageText={<FontAwesomeIcon icon={faAngleRight}/>}
                firstPageText={<FontAwesomeIcon icon={faAnglesLeft}/>}
                lastPageText={<FontAwesomeIcon icon={faAnglesRight}/>}
            />
        )
    }
}
